// The /users pages' whole server surface: sysadmin-only callables in
// functions/lib/users.js, plus the sales ones the users page reuses. Each
// returns the callable's data.
import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase'

// deleteAuthUser can take minutes on someone with many videos; the SDK's
// default 70s would report a failure over a deletion that is still working.
// Matches the function's own timeoutSeconds.
const DELETE_TIMEOUT_MS = 540000

const call = (name, options) => async (data) =>
  (await httpsCallable(functions, name, options)(data)).data

/** @type {(args: {filter?: string, pageToken?: string, query?: string}) => Promise<{users: object[], nextPageToken: ?string}>} */
export const listAuthUsers = call('listAuthUsers')
/** @type {(args: {uid: string}) => Promise<object>} */
export const getAuthUser = call('getAuthUser')
/** @type {(args: {uid: string, eventId: string, role: ?string}) => Promise<{ok: boolean}>} */
export const setEventRole = call('setEventRole')
/** @type {(args: {uid: string, admin: boolean}) => Promise<{ok: boolean}>} */
export const setSysAdmin = call('setSysAdmin')
/** @type {(args: {uid: string, disabled: boolean}) => Promise<{ok: boolean}>} */
export const setAccountDisabled = call('setAccountDisabled')
/** @type {(args: {uid: string, mode: 'access'|'account'|'everything'}) => Promise<{completed: boolean, counts: object, failures: string[]}>} */
export const deleteAuthUser = call('deleteAuthUser', { timeout: DELETE_TIMEOUT_MS })

// Sales — the sales app's own callables (functions/lib/sales/callables.js).
/** @type {(args: {email: string, name: string, kind: 'internal'|'external', role: string, commissionPct: number}) => Promise<object>} */
export const inviteSeller = call('inviteSeller')
/** @type {(args: {uid: string, active: boolean}) => Promise<{ok: boolean}>} */
export const setSellerActive = call('setSellerActive')
/** @type {(args: {uid: string, role: 'seller'|'salesmanager'}) => Promise<{ok: boolean}>} */
export const setSellerRole = call('setSellerRole')
